import Header from './components/Header';
import Hero from './components/Hero';
import Projetos from './components/Projetos';
import Arquiteta from './components/Arquiteta';
import Servicos from './components/Servicos';
import Diferenciais from './components/Diferenciais';
import Processo from './components/Processo';
import Experiencias from './components/Experiencias';
import Contato from './components/Contato';
import Footer from './components/Footer';

export default function Home() {
  return (
    <main className="min-h-screen">
      <Header />
      <Hero />
      <Projetos />
      <Arquiteta />
      <Servicos />
      <Diferenciais />
      <Processo />
      <Experiencias />
      <Contato />
      <Footer />
    </main>
  );
}
